import React from "react";
import Stack from "../Stack";
const LayoutButtons = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: 2,
    direction: "row-reverse"
  }, children);
};
export default LayoutButtons;